import { useState, useEffect, useRef } from "react";
import uuid4 from "uuid4";

const TYPING_SPEED_MS = 100;

const useChatStreaming = ({ typingSpeedMs = TYPING_SPEED_MS, onStreamComplete }) => {
    const [streamingState, setStreamingState] = useState(null);
    const streamingStateRef = useRef(null);
    const onStreamCompleteRef = useRef(onStreamComplete);

    useEffect(() => {
        onStreamCompleteRef.current = onStreamComplete;
    });

    useEffect(() => {
        if (!streamingState) return;

        const words = streamingState.fullText.split(' ');
        let currentWordIndex = 0;

        const intervalId = setInterval(() => {
            if (currentWordIndex < words.length) {
                const newDisplayText = words.slice(0, currentWordIndex + 1).join(' ');
                setStreamingState(prev => ({ ...prev, displayText: newDisplayText }));
                currentWordIndex++;
            } else {
                clearInterval(intervalId);
                const finalMessage = {
                    id: streamingState.id,
                    text: streamingState.fullText,
                    user: 'bot',
                    timestamp: new Date().toISOString(),
                };
                onStreamCompleteRef.current(streamingState.chatId, finalMessage);
                streamingStateRef.current = null;
                setStreamingState(null);
            }
        }, typingSpeedMs);

        return () => clearInterval(intervalId);
    }, [streamingState?.id]);

    const startStream = ({ chatId, text }) => {
        if (streamingStateRef.current) {
            onStreamCompleteRef.current(streamingStateRef.current.chatId, {
                id: streamingStateRef.current.id,
                text: streamingStateRef.current.fullText,
                user: 'bot',
                timestamp: new Date().toISOString(),
            });
        }
        const newState = { chatId, fullText: text, displayText: '', id: uuid4() };
        streamingStateRef.current = newState;
        setStreamingState(newState);
    };

    const cancelStream = () => {
        streamingStateRef.current = null;
        setStreamingState(null);
    };

    return { streamingState, startStream, cancelStream };
};

export default useChatStreaming;
